var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.314 1.713l.322-.344v-.026l-.337.356.015.014zm-13 4.69l.001.025.37.296.011-.014-.383-.307zM14.28.287l1.421 1.379-9.393 10.013L.304 6.876l1.212-1.568 4.602 3.68L14.28.288z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3csvg width='16px' height='12px' viewBox='0 0 16 12' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg transform='translate(-58.000000, -14.000000)' fill='%23FFFFFF'%3e %3cg transform='translate(54.000000, 8.000000)'%3e %3cpath d='M18.3136362,7.71301485 L18.6360088,7.36934666 L18.6353838,7.34268869 L18.2990357,7.69884361 L18.3136362,7.71301485 Z M5.31339777,12.4034164 L5.31535398,12.4279974 L5.68535858,12.7239424 L5.69635283,12.7097196 L5.31339777,12.4034164 Z M18.2802035,6.28698515 L19.7009643,7.66597596 L10.3083211,17.6790879 L4.30364717,12.8763019 L5.51599094,11.3079495 L10.1177586,14.9886332 L18.2802035,6.28698515 Z'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgCheck as ReactComponent };